// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donation-prompt-backdrop {
  align-items: center;
  background: rgba(18, 35, 45, 0.52);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;
}

.donation-prompt {
  background: #ffffff;
  border: 3px solid #3f7986;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(18, 57, 77, 0.28);
  color: #1f1f1f;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  max-width: 460px;
  padding: 34px;
  position: relative;
  text-align: center;
  width: 100%;
}

.donation-prompt__close {
  align-items: center;
  background: transparent;
  border: 0;
  color: #666666;
  cursor: pointer;
  display: inline-flex;
  font-size: 30px;
  height: 38px;
  justify-content: center;
  line-height: 1;
  position: absolute;
  right: 12px;
  top: 10px;
  width: 38px;
}

.donation-prompt[dir="rtl"] .donation-prompt__close {
  left: 12px;
  right: auto;
}

.donation-prompt__close:hover {
  color: #cc0000;
}

.donation-prompt__title {
  color: #12394d;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.15;
  margin: 0 24px 12px;
}

.donation-prompt__body {
  color: #555555;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.45;
  margin: 0 auto 26px;
}

.donation-prompt__actions {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: center;
}

.donation-prompt__donate,
.donation-prompt__continue {
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 800;
  justify-content: center;
  min-height: 46px;
  padding: 0 20px;
  text-decoration: none;
}

.donation-prompt__donate {
  background: #cc0000;
  border: 2px solid #cc0000;
  color: #ffffff;
}

.donation-prompt__donate:hover {
  background: #a90000;
  border-color: #a90000;
  color: #ffffff;
}

.donation-prompt__continue {
  background: #ffffff;
  border: 2px solid #3f7986;
  color: #3f7986;
}

.donation-prompt__continue:hover {
  background: #edf3f4;
}

@media (max-width: 520px) {
  .donation-prompt {
    padding: 30px 22px 24px;
  }

  .donation-prompt__title {
    font-size: 25px;
  }

  .donation-prompt__body {
    font-size: 16px;
  }

  .donation-prompt__actions {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/donation-prompt.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".donation-prompt-backdrop {\n  align-items: center;\n  background: rgba(18, 35, 45, 0.52);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  padding: 24px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 2000;\n}\n\n.donation-prompt {\n  background: #ffffff;\n  border: 3px solid #3f7986;\n  border-radius: 20px;\n  box-shadow: 0 24px 60px rgba(18, 57, 77, 0.28);\n  color: #1f1f1f;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  max-width: 460px;\n  padding: 34px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n\n.donation-prompt__close {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  color: #666666;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 30px;\n  height: 38px;\n  justify-content: center;\n  line-height: 1;\n  position: absolute;\n  right: 12px;\n  top: 10px;\n  width: 38px;\n}\n\n.donation-prompt[dir=\"rtl\"] .donation-prompt__close {\n  left: 12px;\n  right: auto;\n}\n\n.donation-prompt__close:hover {\n  color: #cc0000;\n}\n\n.donation-prompt__title {\n  color: #12394d;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.15;\n  margin: 0 24px 12px;\n}\n\n.donation-prompt__body {\n  color: #555555;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.45;\n  margin: 0 auto 26px;\n}\n\n.donation-prompt__actions {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.donation-prompt__donate,\n.donation-prompt__continue {\n  align-items: center;\n  border-radius: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 800;\n  justify-content: center;\n  min-height: 46px;\n  padding: 0 20px;\n  text-decoration: none;\n}\n\n.donation-prompt__donate {\n  background: #cc0000;\n  border: 2px solid #cc0000;\n  color: #ffffff;\n}\n\n.donation-prompt__donate:hover {\n  background: #a90000;\n  border-color: #a90000;\n  color: #ffffff;\n}\n\n.donation-prompt__continue {\n  background: #ffffff;\n  border: 2px solid #3f7986;\n  color: #3f7986;\n}\n\n.donation-prompt__continue:hover {\n  background: #edf3f4;\n}\n\n@media (max-width: 520px) {\n  .donation-prompt {\n    padding: 30px 22px 24px;\n  }\n\n  .donation-prompt__title {\n    font-size: 25px;\n  }\n\n  .donation-prompt__body {\n    font-size: 16px;\n  }\n\n  .donation-prompt__actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
